import { render, staticRenderFns } from "./MenuSell.vue?vue&type=template&id=70b24096&scoped=true&"
import script from "./MenuSell.vue?vue&type=script&lang=js&"
export * from "./MenuSell.vue?vue&type=script&lang=js&"
import style0 from "./MenuSell.vue?vue&type=style&index=0&id=70b24096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b24096",
  null
  
)

export default component.exports